import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'

import Button from 'components/UI/Button/Button'

import {
  Title,
  Wrapper,
  TextImageWrapper,
  TextWrapper,
  List,
  ListItem,
  Image,
  Paragraph
} from './Ambassador.styles'
import { GradientWrapper } from '../../../../DashboardSettings.styles'

import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

const messages = defineMessages({
  ambassadorHelp: {
    id: 'dashboard.referrals.ambassadorHelp',
    defaultMessage: 'How you can help as a Night Zookeeper Ambassador'
  },
  presentMeetings: {
    id: 'dashboard.referrals.presentMeetings',
    defaultMessage: 'Present Night Zookeeper at team and staff meetings'
  },
  shareReport: {
    id: 'dashboard.referrals.shareReport',
    defaultMessage: 'Share your class report with your colleagues and senior leaders in your school'
  },
  sharePosts: {
    id: 'dashboard.referrals.sharePosts',
    defaultMessage: 'Share posts about Night Zookeeper on social media'
  },
  supportColleagues: {
    id: 'dashboard.referrals.supportColleagues',
    defaultMessage: 'Support your colleagues to get started on the website'
  },
  applyAmbassador: {
    id: 'dashboard.referrals.applyAmbassador',
    defaultMessage: 'Apply to become an ambassador'
  },
  ambassadorThanks: {
    id: 'dashboard.referrals.ambassadorThanks',
    defaultMessage: 'Thanks for your interest in becoming a Night Zookeeper ambassador! A member of our team will be in touch with you soon.'
  }
})

export default class Ambassador extends Component {
  static propTypes = {
    // sendAmbassadorEmail: PropTypes.func,
    // buttonClicked: PropTypes.bool,
    ambassador: PropTypes.bool
  }

  // static defaultProps = {
  //   buttonClicked: false,
  //   ambassador: false
  // }

  render () {
    const { direction, ambassador, sendAmbassadorEmail, ambassadorEmailSent } = this.props

    const ambassadorStatus = ambassadorEmailSent || ambassador
      ? <Paragraph>
        <FormattedMessage {...messages.ambassadorThanks} />
      </Paragraph>
      : <Button bgColor={colors.blue} color={colors.white} size='small' onClick={sendAmbassadorEmail}>
        <FormattedMessage {...messages.applyAmbassador} />
      </Button>

    return (
      <GradientWrapper direction={direction}>
        <Wrapper>
          <TextImageWrapper>
            <TextWrapper>
              <Title>
                <FormattedMessage {...messages.ambassadorHelp} />
              </Title>
              <List>
                <ListItem>
                  <FormattedMessage {...messages.presentMeetings} />
                </ListItem>
                <ListItem>
                  <FormattedMessage {...messages.shareReport} />
                </ListItem>
                <ListItem>
                  <FormattedMessage {...messages.sharePosts} />
                </ListItem>
                <ListItem>
                  <FormattedMessage {...messages.supportColleagues} />
                </ListItem>
              </List>
              {ambassadorStatus}
            </TextWrapper>
            <Image />
          </TextImageWrapper>
        </Wrapper>
      </GradientWrapper>
    )
  }
}
